import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { List, X, ArrowUpRight } from "@phosphor-icons/react";
import { AnimatePresence, motion } from "framer-motion";
import { NAV } from "../data/content";
import { Btn } from "./Btn";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ballk-pm/artifacts/qei90dxd_Logo%20Nieuw%20ChatGPT%20Image%2013%20jul%202026%2C%2012_55_25.png";

const Logo = () => (
  <Link to="/" data-testid="nav-logo" className="flex items-center group">
    <img src={LOGO_URL} alt="BALLK Project" className="h-20 md:h-28 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]" />
  </Link>
);

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-b border-ballk-light py-3" : "bg-transparent py-5"
      }`}
    >
      <nav className="container-ballk flex items-center justify-between">
        <Logo />
        <div className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`relative text-sm font-body font-medium transition-colors hover:text-ballk-purple ${
                pathname === n.to ? "text-ballk-purple" : "text-ballk-indigo"
              }`}
            >
              {n.label}
              {pathname === n.to && (
                <motion.span layoutId="nav-underline" className="absolute -bottom-1.5 left-0 h-0.5 w-full bg-ballk-purple" />
              )}
            </Link>
          ))}
        </div>
        <div className="hidden md:block">
          <Btn to="/contact" data-testid="nav-cta" className="px-5 py-2.5">
            Neem contact op <ArrowUpRight size={16} weight="bold" />
          </Btn>
        </div>
        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-ballk-indigo p-2"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden overflow-hidden bg-white border-t border-ballk-light"
          >
            <div className="container-ballk py-6 flex flex-col gap-4">
              {NAV.map((n) => (
                <Link key={n.to} to={n.to}
                  data-testid={`mobile-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-lg font-heading font-semibold text-ballk-indigo">
                  {n.label}
                </Link>
              ))}
              <Btn to="/contact" className="mt-2 w-full">Neem contact op</Btn>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
